// planHistoryService.ts
import { axiosInstance } from './axiosConfig';
import { handleRequestWithAuth } from './refreshService';

const PLAN_HISTORY_API_URL = 'plan-history/';

export const fetchPlanHistory = async () => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get(PLAN_HISTORY_API_URL);
        return response.data;
    });
};